const clearfix = {
  '&:after': {
    content: '',
    display: 'block',
    clear: 'both',
  },
};

export default clearfix;
